import { generateId } from "./../../ricos-content/index.js";
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { captionDefaultAttributes } from "./../../_shared/figure/consts.js";
const captionConverter = {
  toPm: {
    types: [Node_Type.CAPTION],
    // @ts-ignore $TSFixMe
    convert: (node, visit) => {
      const { style, captionData } = node || {};
      return {
        type: Node_Type.CAPTION,
        attrs: {
          ...captionData,
          ...style ? { style } : {},
          id: node.id ?? generateId()
        },
        content: visit(node)
      };
    }
  },
  fromPm: {
    types: [Node_Type.CAPTION],
    // @ts-ignore $TSFixMe
    convert: (node, visit) => {
      const { id, style, dir: _, textStyle } = node.attrs || {};
      const transformedStyle = {
        paddingBottom: excludeDefaultValue(
          style?.paddingBottom,
          captionDefaultAttributes.styleDefaults.paddingBottom
        ),
        paddingTop: excludeDefaultValue(
          style?.paddingTop,
          captionDefaultAttributes.styleDefaults.paddingTop
        )
      };
      const transformedTextStyle = {
        textAlignment: excludeDefaultValue(
          textStyle?.textAlignment,
          captionDefaultAttributes.textStyle.textAlignment
        ),
        lineHeight: excludeDefaultValue(
          textStyle?.lineHeight,
          captionDefaultAttributes.textStyle.lineHeight
        )
      };
      return {
        type: Node_Type.CAPTION,
        id,
        nodes: visit(node),
        ...Object.values(transformedStyle).some((v) => v !== void 0) && {
          style: transformedStyle
        },
        ...Object.values(transformedTextStyle).some((v) => v !== void 0) && {
          captionData: { textStyle: transformedTextStyle }
        }
      };
    }
  }
};
const createCaptionTiptapNode = (content) => {
  return {
    type: Node_Type.CAPTION,
    attrs: {
      id: generateId()
    },
    content: content ?? []
  };
};
function excludeDefaultValue(value, defaultValue) {
  return value === defaultValue ? void 0 : value;
}
export {
  captionConverter,
  createCaptionTiptapNode
};
//# sourceMappingURL=caption-converter.js.map
